import React from 'react';
import WorkshopsSection from '../components/WorkshopsSection';

const WorkshopsPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-nitzan-light-bg via-white to-nitzan-sage/10">
      <div className="pt-20">
        <WorkshopsSection />
      </div>
    </div>
  );
};

export default WorkshopsPage;

